export default __webpack_public_path__ + "static/media/icn_scriptee.2b702903.svg";